module.exports = __webpack_public_path__ + "img/RY_1000_1-1.2f8736dd.png";